import useImportFile, { entityName } from '@hooks/api/mutations/useImportFile';
import QueryKeys from '@src/constants/queryKeys';
import useExportControlModeTemplates from '@src/hooks/api/queries/modes/useExportControlModeTemplates';
import useTemplateValidation from '@src/hooks/useTemplateValidation';
import { ImportControlModeTemplateResponseDto } from '@src/types/ControlModes';
import React from 'react';
import FileToolbar from '../../_shared/FileToolbar';

interface TemplatesToolbarProps {
  handleAdd: () => void;
  onImportSuccess?: (result: ImportControlModeTemplateResponseDto) => void;
}

export default function TemplatesToolbar({
  handleAdd,
  onImportSuccess,
}: TemplatesToolbarProps): React.ReactElement {
  const { exportTemplates, isExporting } = useExportControlModeTemplates();
  const {
    importFile,
    isImporting,
    error: importApiError,
  } = useImportFile(entityName.TEMPLATES);
  const validation = useTemplateValidation();

  return (
    <FileToolbar
      handleAdd={handleAdd}
      importFile={importFile}
      exportFile={exportTemplates}
      queryKey={[QueryKeys.controlModeTemplates]}
      entityName='TEMPLATE'
      validation={validation}
      importHook={{ isImporting, error: importApiError }}
      exportHook={{ isExporting }}
      onImportSuccess={onImportSuccess}
    />
  );
}
